import { PbhRemoveReasonType } from "../../../../../Enums/PbhRemoveReasonType";

export const RemoveDateFromAcNonRequiredStatus = [
  PbhRemoveReasonType.ServiceableReturn,
  PbhRemoveReasonType.RejectedQuarantinedPart,
  PbhRemoveReasonType.ShelfLifeExpiration,
];
